import React, { useState } from "react";
import { addFeedback } from "../firebase";
import { motion, AnimatePresence } from "framer-motion";

import FeedbackModal from "./FeedbackModal";
// import AdSlot from "./AdSlot";

const SwapResult = ({ swapOption, swapComment, isConditionFriendly, food, user }) => {

  const [showFeedback, setShowFeedback] = useState(false);

  if (!swapOption) return null;
  return (
    <div style={{ position: "relative", minHeight: "150px", transition: "opacity 0.3s ease" }}>
      <AnimatePresence mode="wait">
        {swapOption && (
          <motion.div
            key={swapOption.swap + swapOption.explanation}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            {/* {isConditionFriendly && swapComment && ( */}
            {swapComment && (
              <div style={{ color: "#006400", fontSize: "1rem", marginBottom: "0.5rem" }}>
                {swapComment}
              </div>
            )}

            <strong>Suggested Swap:</strong>
            <p><strong>{swapOption.swap}</strong></p>
            <p><em>Why:</em> {swapOption.explanation}</p>

            {/* <div style={{ marginTop: "1rem" }}>
              <AdSlot type="inline" user={user} key={`ad-${swapOption?.swap}`} />
            </div> */}

          </motion.div>
        )}
      </AnimatePresence>

      <FeedbackModal
        open={showFeedback}
        onClose={() => setShowFeedback(false)}
        onSubmit={async (feedbackText) => {
          await addFeedback({
            food,
            swap: swapOption.swap,
            explanation: swapOption.explanation,
            feedback: feedbackText,
            user
          });
          // setShowFeedback(false);
        }}
        food={food}
        swap={swapOption.swap}
        explanation={swapOption.explanation}
      />




    </div>
  );
};

export default SwapResult;
